import ShareModal from "./ShareModal";
import type { ShareModalProps } from "./ShareModal";
import NiceModal from "@ebay/nice-modal-react";

/**
 * 显示分享弹窗
 * @param props 分享弹窗的 props
 * @returns 分享弹窗的实例
 */
export function showShareModal(props?: ShareModalProps) {
  return NiceModal.show(ShareModal, props);
}

/**
 * 隐藏分享弹窗
 */
export function hideShareModal() {
  NiceModal.hide(ShareModal);
}

export default ShareModal;